(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('ExaminerSelectionDialogController', ExaminerSelectionDialogController);

    function ExaminerSelectionDialogController(logger, $uibModalInstance, $translate, userQuality, activity, dataService) {
        var vm = this;

        vm.userQuality = userQuality;
        vm.activity = activity;
        vm.examiner = vm.activity.examiner == null ? { idString: null, name: null } : { idString: vm.activity.examiner.idString, name: vm.activity.examiner.name };
        
        vm.cancel = cancel;
        vm.identitySelected = identitySelected;
        vm.revokeRequest = revokeRequest;
        vm.save = save;
        vm.theOnlyExaminerIsTheEmployee = (vm.activity.examiners.length === 1 && vm.activity.examiners[0].idString === vm.userQuality.studentIdString);
     
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function identitySelected(identity) {
            vm.examiner = { idString: identity.idString, name: identity.displayName };
        }

        function revokeRequest() {
            return dataService
                .deleteExaminerFromUserQualityActivity(vm.userQuality.id, vm.activity.id)
                .then(result => {
                    logger.success('request_revoked');
                    $uibModalInstance.close(result);
                });
        }

        function save() {
            return dataService.setExaminerForUserQualityActivity(vm.userQuality.id, vm.activity.id, vm.examiner.idString, vm.examiner.name)
                .then(result => {
                    logger.success('assessment_requested');
                    $uibModalInstance.close(result);
                });
        }
    }
})();
